import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { EMPTY, Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { Status } from '../../../../core/rex/_models/status.model';
import { ShipmentService } from '../../../../core/rex/_services/shipment.service';

@Component({
  selector: 'kt-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss'],
})
export class TrackingComponent implements OnInit {
  trackingControl: UntypedFormControl;
  trackingResults$: Observable<Status[]> | null = null;
  isLoading = false;
  errorMessage = '';
  hasSearched = false;
  isCourierCenter = false;

  constructor(
    private shipmentService: ShipmentService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.trackingControl = new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(5),
    ]);
  }

  get isFormValid(): boolean {
    return this.trackingControl.valid && this.trackingControl.value?.trim();
  }

  searchTracking(): void {
    if (!this.isFormValid) {
      return;
    }

    const trackingString = this.trackingControl.value.trim();
    this.isLoading = true;
    this.errorMessage = '';
    this.hasSearched = true;
    this.trackingResults$ = null;

    this.trackingResults$ = this.shipmentService
      .trackShipment(trackingString)
      .pipe(
        catchError(error => {
          console.log('Error fetching tracking results:', error);

          // Check for specific "No shipment found" message
          if (
            error.status === 400 ||
            (error.error &&
              typeof error.error === 'string' &&
              error.error.includes('No shipment found')) ||
            (error.error &&
              error.error.detail &&
              error.error.detail.includes('No shipment found'))
          ) {
            this.errorMessage = 'Δεν βρέθηκε αποστολή με αυτόν τον κωδικό';
          } else if (error.status === 500) {
            // Server error - could be our tracking endpoint issue
            this.errorMessage =
              'Σφάλμα κατά την αναζήτηση. Παρακαλώ ξαναπροσπαθήστε';
          } else {
            // Generic error for other cases
            this.errorMessage =
              'Σφάλμα κατά την αναζήτηση. Παρακαλώ ξαναπροσπαθήστε';
          }

          this.isLoading = false;
          this.cdr.markForCheck();
          return EMPTY;
        }),
        finalize(() => {
          this.isLoading = false;
        })
      );

    // Subscribe to check if courier is courier center for styling
    this.trackingResults$.subscribe({
      next: results => {
        if (results && results.length > 0) {
          // Check if any result indicates courier center (based on shipment-view-bs logic)
          this.isCourierCenter = results.some(
            status =>
              status._station &&
              status._station.toLowerCase().includes('courier center')
          );
        }
      },
      error: () => {
        console.log('error');
        // Error already handled in catchError above
      },
    });
  }

  clearSearch(): void {
    this.trackingControl.reset();
    this.trackingResults$ = null;
    this.errorMessage = '';
    this.hasSearched = false;
    this.isCourierCenter = false;
  }
}
